export const SYNC_APP_CONNECTION_MAX_ATTEMPTS = 3;
export const SYNC_APP_CONNECTION_RETRY_DELAY_MS = 2000;

export const waitForSyncAppConnection = async (
  checkConnection: () => Promise<boolean>,
  { maxAttempts = SYNC_APP_CONNECTION_MAX_ATTEMPTS, retryDelayMs = SYNC_APP_CONNECTION_RETRY_DELAY_MS } = {}
): Promise<boolean> => {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    const isConnected = await checkConnection().catch(() => false);

    if (isConnected) return true;

    if (attempt < maxAttempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
    }
  }

  return false;
};
